import { isNil } from 'lodash-es';

import { ISanityItemOption, ISanityItemOptionModifier } from '@rbi-ctg/menu';

import { and, compose, get, minLengthWithDefaultValue, not } from '..';

import { onlyDefaultModifierIsAvailable } from './only-default-modifier-is-available';

export const shouldDisplayItemOption = compose<
  [ISanityItemOption],
  ISanityItemOptionModifier[],
  boolean
>(
  and(not(isNil), and(minLengthWithDefaultValue(1, []), not(onlyDefaultModifierIsAvailable))),
  get('options')
);
